import { RUNE_GRAY_700 } from 'theme/colors'

export const LEGEND_TEXT_STYLE = {
  color: RUNE_GRAY_700,
  fontSize: '0.875rem',
  fontWeight: 400,
}
